// WARNING: This file is auto-generated by 'generate-routes.ts', do not edit directly
export const routes = {
  Routes: {
    fourOhFour: '/404',
    account: '/account',
    apiAuthTestsConvertCredentiailsUnitTest:
      '/api/auth/__tests__/convertCredentiails.unit.test',
    apiAuthConvertCredentialsTs: '/api/auth/convertCredentials.ts',
    apiClinicPricing: '/api/clinic-pricing',
    apiGetaddress: '/api/getaddress',
    apiGetaddresses: '/api/getaddresses',
    apiPricing: '/api/pricing',
    clinicGenerateAQuote: '/clinic/generate-a-quote',
    getStarted: '/get-started',
    passwordReset: '/password-reset',
    profileChecksAffordability: '/profile/checks/affordability',
    profileChecksAffordabilityPartner: '/profile/checks/affordability/partner',
    profileChecksAffordabilitySelf: '/profile/checks/affordability/self',
    profileChecksOpenBankingSuccess: '/profile/checks/open-banking/success',
    profileChecksTreatmentProof: '/profile/checks/treatment-proof',
    profile: '/profile',
    profileQuoteCollections: '/profile/quote-collections',
    profileQuotes: '/profile/quotes',
    profileTreatmentUpdate: '/profile/treatment/update',
    registerEmailConfirmation: '/register/email-confirmation',
    register: '/register',
    signIn: '/sign-in',
    signUp: '/sign-up',
    treatmentHealth: '/treatment/health',
    treatmentJourney: '/treatment/journey',
    welcome: '/welcome',
    welcomePartnerName: '/welcome/partner-name',
    welcomePartner: '/welcome/partner',
  },
  DynamicRoutes: {
    apiAuthNextauth: '/api/auth/[...nextauth]',
    emailVerificationToken: '/email-verification/[token]',
    passwordResetToken: '/password-reset/[token]',
    profileQuoteCollectionsQuoteCollectionId:
      '/profile/quote-collections/[quoteCollectionId]',
    profileQuotesQuoteId: '/profile/quotes/[quoteId]',
  },
} as const
